import React, { Component } from 'react';
import { Button, TextField, Paper, Typography, Box } from '@material-ui/core';
import { connect } from 'react-redux';
import { sendWhatsAppOTP, verifyWhatsAppOTP, checkWhatsAppOTPRequired } from '../store/actions/opinionActions';
import { showToast } from '../store/actions/toastAction';

class TestOTP extends Component {
  state = {
    userID: '',
    testOTP: '',
    result: ''
  };

  handleCheckOTP = async () => {
    const { userID } = this.state;
    if (!userID) {
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Please enter a userID'
      });
      return;
    }

    try {
      const required = await checkWhatsAppOTPRequired(userID);
      this.setState({ result: `OTP Required: ${required}` });
    } catch (error) {
      this.setState({ result: `Error: ${error.message}` });
    }
  };

  handleSendOTP = async () => {
    const { userID } = this.state;
    if (!userID) {
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Please enter a userID'
      });
      return;
    }

    try {
      const result = await sendWhatsAppOTP(userID);
      this.setState({ result: `Send Result: ${JSON.stringify(result)}` });
      
      if (result.success) {
        this.props.showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'success',
          message: 'OTP sent successfully!'
        });
      } else {
        this.props.showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'error',
          message: result.message
        });
      }
    } catch (error) {
      this.setState({ result: `Error: ${error.message}` });
    }
  };

  handleVerifyOTP = async () => {
    const { userID, testOTP } = this.state;
    if (!userID || !testOTP) {
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Please enter userID and OTP'
      });
      return;
    }

    try {
      const result = await verifyWhatsAppOTP(userID, testOTP);
      this.setState({ result: `Verify Result: ${JSON.stringify(result)}` });
      
      if (result.success) {
        this.props.showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'success',
          message: 'OTP verified successfully!'
        });
      } else {
        this.props.showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'error',
          message: result.message
        });
      }
    } catch (error) {
      this.setState({ result: `Error: ${error.message}` });
    }
  };

  render() {
    const { userID, testOTP, result } = this.state;

    return (
      <Paper style={{ padding: '20px', margin: '20px', maxWidth: '500px' }}>
        <Typography variant="h6" gutterBottom>
          WhatsApp OTP Test Panel
        </Typography>
        
        <Box mb={2}>
          <TextField
            label="User ID"
            value={userID}
            onChange={(e) => this.setState({ userID: e.target.value })}
            fullWidth
            margin="normal"
            placeholder="Enter userID to test"
          />
        </Box>

        <Box mb={2}>
          <TextField
            label="OTP Code (for verification test)"
            value={testOTP}
            onChange={(e) => this.setState({ testOTP: e.target.value })}
            fullWidth
            margin="normal"
            placeholder="Enter 6-digit OTP"
          />
        </Box>

        <Box mb={2}>
          <Button 
            variant="outlined" 
            onClick={this.handleCheckOTP}
            style={{ marginRight: '10px' }}
          >
            Check OTP Required
          </Button>
          
          <Button 
            variant="contained" 
            color="primary" 
            onClick={this.handleSendOTP}
            style={{ marginRight: '10px' }}
          >
            Send OTP
          </Button>
          
          <Button 
            variant="contained" 
            color="secondary" 
            onClick={this.handleVerifyOTP}
          >
            Verify OTP
          </Button>
        </Box>

        {result && (
          <Box mt={2}>
            <Typography variant="body2" style={{ 
              backgroundColor: '#f5f5f5', 
              padding: '10px', 
              borderRadius: '4px',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap'
            }}>
              {result}
            </Typography>
          </Box>
        )}

        <Box mt={2}>
          <Typography variant="caption" color="textSecondary">
            Instructions:<br/>
            1. Enter your userID (check browser console or profile)<br/>
            2. Click "Check OTP Required" to see if WhatsApp is enabled<br/>
            3. Click "Send OTP" to send a test OTP<br/>
            4. Enter the received OTP and click "Verify OTP"<br/>
            Check browser console for detailed logs.
          </Typography>
        </Box>
      </Paper>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  showToast: (params) => dispatch(showToast(params)),
});

export default connect(null, mapDispatchToProps)(TestOTP); 